import { createContext, useContext, useEffect, useState } from 'react'

interface UserActivityContextValue {
  lastActivity: number
}

const UserActivityContext = createContext<UserActivityContextValue>({
  lastActivity: Date.now(),
})

// Provider
export const UserActivityProvider = ({
  children,
}: {
  children: React.ReactNode
}) => {
  const [lastActivity, setLastActivity] = useState(Date.now())

  useEffect(() => {
    const update = () => setLastActivity(Date.now())

    window.addEventListener('mousemove', update)
    window.addEventListener('keydown', update)
    window.addEventListener('click', update)
    window.addEventListener('touchstart', update)

    return () => {
      window.removeEventListener('mousemove', update)
      window.removeEventListener('keydown', update)
      window.removeEventListener('click', update)
      window.removeEventListener('touchstart', update)
    }
  }, [])

  return (
    <UserActivityContext.Provider value={{ lastActivity }}>
      {children}
    </UserActivityContext.Provider>
  )
}

// Hook to read the context
export const useUserActivity = () => useContext(UserActivityContext)
